/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

/** @description import Global or some other files only if you need them */
import Global from './global';

'use strict';
const AjaxLogin = {
	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */

	init: function() {
		const popup = document.getElementsByClassName('js-popup-login-form');
		if (popup.length !== 0) {
			this.closeFormEvent();
			Global.functions.clickOutsideContainer($('.js-popup-login-form'), $('.js-woocommerce-form-login'), $('.js-close-popup-login-form'), function() {
				$.fancybox.close();
				setTimeout(() => {
					$('.js-popup-login-form').removeClass('active');
				}, 100);
			});
			Global.functions.escKey(function() {
				$.fancybox.close();
				setTimeout(() => {
					$('.js-popup-login-form').removeClass('active');
				}, 100);
			});
			//username
			const trigger = document.querySelector('.js-trigger-login');
			trigger.addEventListener('click', function() {
				AjaxLogin.triggerLogin();
			});

			const pass = document.getElementById('password');
			pass.onkeypress = (e) => {
				if (e.which === 13) {
					AjaxLogin.triggerLogin();
				}
			};
			const username = document.getElementById('username');
			username.onkeypress = (e) => {
				if (e.which === 13) {
					AjaxLogin.triggerLogin();
				}
			};
		}
	},

	closeForm: function() {
		$('.js-popup-login-form').removeClass('active');
		$('.js-login-loader').removeClass('active');
        $('#fws-login-popup-controls').show();
        $('#fws-login-popup-2fa').html('');
	},

	closeFormEvent: function() {
		const close = document.getElementsByClassName('js-close-popup-login-form');
		close[0].addEventListener('click', function() {
			AjaxLogin.closeForm();
		});
	},

	triggerLogin: function() {
		const email = document.getElementsByClassName('js-login-input-email');
		const pass = document.getElementsByClassName('js-login-input-pass');
		//const popup = document.getElementsByClassName('js-popup-login-form');
		//const id = popup[0].getAttribute('data-id');
		const loginNonce = document.getElementById('woocommerce-login-nonce').value;

		const data = {
			action: 'check_login_parameters',
			emailCheck: email[0].value,
			passCheck: pass[0].value,
			//idProduct: id,
			wooLoginNonce: loginNonce,
			url: window.location.href
		};
		AjaxLogin.ajaxFunc(data);
		$('.js-login-loader').addClass('active');
        $('.js-error-holder').html('');
	},

	// ajax function
	ajaxFunc: function(data) {
		$.ajax({
			type: 'POST',
			url: kadraGlobal.ajax,
			data: data,
			success: (response) => {
				AjaxLogin.handleResponse2FA(response)
                || AjaxLogin.handleResponseError(response)
                || AjaxLogin.handleResponseSuccess(response);
			}
		});
	},

    // handle "2FA" response
    handleResponse2FA: function (response) {
        if (typeof response !== 'string') {
            return false; // it is JSON response
        }
        if (response.includes('<strong>Error:</strong>')) {
            return false; // it is error message
        }
        $('#fws-login-popup-controls').hide();
        let container2fa = $('#fws-login-popup-2fa');
        if (container2fa.length === 0) {
            $('.js-woocommerce-form-login').append('<div id="fws-login-popup-2fa"></div>');
            container2fa = $('#fws-login-popup-2fa');
        }
        container2fa.html(response);
        return true;
    },

    // handle "error" response
    handleResponseError: function (response) {
        if (response.success) {
            return false;
        }
        const errorHolder = document.getElementsByClassName('js-error-holder');
        errorHolder[0].innerHTML = '';
        errorHolder[0].innerHTML = response;
        $('.js-login-loader').removeClass('active');
        return true;
    },

    // handle "success" response
    handleResponseSuccess: function (response) {
        const href = window.location.href.replace(/\/$/, "");
        const url = href.substring(href.lastIndexOf('/') + 1);
        const n = url.includes('?s=');
        setTimeout(() => {
            $('.js-login-loader').removeClass('active');
        }, 500);
        if (n) {
            window.location.href = kadraGlobal.Url + '/' + url;
            return;
        }
        if (href.split('/')[3] === 'shop') {
            window.location.href = kadraGlobal.Url + '/shop/' + url;
            return;
        }
        if (href.split('/')[3] === 'product-category') {
            window.location.href = kadraGlobal.Url + '/product-category/' + url;
            return;
        }
        if (href.split('/')[3] === 'product') {
            window.location.href = kadraGlobal.Url + '/product/' + url;
            return;
        }
        window.location.href = kadraGlobal.Url;
    },


};

export default AjaxLogin;
